/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Carousel } from 'react-bootstrap';
import { setIcon } from './hotspotIcon';
import '../../../assets/scss/hotspot.scss';
import ModalComponent from '../../utils/modal';

const HotspotViewComponent = (props: any) => {
  const { parameters, customisations } = props;
  const [show, setShow] = useState(false);
  const [label, setLabel] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    document.addEventListener('click', () => {
      const modalComponent = document.getElementsByClassName('modal-content')?.[0];
      const documentHeight = document.documentElement.getBoundingClientRect();
      let documentClientHeight = documentHeight?.height;
      if (!modalComponent) return;
      setTimeout(() => {
        const height = modalComponent?.clientHeight;
        document.body.style.height =
          height === 0 || height < documentClientHeight ? '' : `${height + 100}px`;
      }, 200);
    });
    setComponent(parameters, customisations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parameters, customisations]);

  const setComponent = (parameters: any, customisations: any) => {
    const icon = setIcon(customisations);
    parameters.map((content: any, index: number) => {
      const element = document.createElement('div');
      element.innerHTML = content.background;
      const image = element.getElementsByTagName('img');
      let source = image[0].src;
      let html = new Image();
      html.id = `image_${index}`;
      html.src = source;
      html.className = 'image-uploading';
      html.tabIndex = 0;
      html.alt = image[0].alt ? image[0].alt : '';
      html.role = html.alt === '' ? 'presentation' : '';
      let imageDiv = document.getElementById(`hotspot_${index}`);
      imageDiv?.getElementsByTagName('img')[0]?.remove();
      content.dropZone.map((value: any) => {
        html.addEventListener('load', function () {
          let hotspots = document.getElementById(`${value.data.label}_${index}`);

          if (hotspots) {
            const refW = value.data.imgWidth || html.naturalWidth;
            const refH = value.data.imgHeight || html.naturalHeight;
            let numericLeft = (value.data.x / refW) * 100;
            let numericTop = (value.data.y / refH) * 100;
            const iconSize = parseInt(customisations.fontSize) || 24;
            const iconWidthPercent = (iconSize / html.clientWidth) * 100;
            const iconHeightPercent = (iconSize / html.clientHeight) * 100;
            let safeLeft = Math.max(0, Math.min(numericLeft, 100 - iconWidthPercent));
            let safeTop = Math.max(0, Math.min(numericTop, 100 - iconHeightPercent));

            let width = iconSize + 'px';
            let height = iconSize + 'px';
            hotspots.setAttribute(
              'style',
              `left:${safeLeft}%;top:${safeTop}%; width:${width};height:${height};background-size:100% 100%;background-repeat:no-repeat;position: absolute;`,
            );
            hotspots.innerHTML = `
              <span style="
                display:flex;
                align-items:center;
                justify-content:center;
                width:100%;
                height:100%;
              ">
                ${icon}
              </span>
         `;
          }
        });
        return null;
      });
      imageDiv?.insertBefore(html, imageDiv.firstChild);
      return imageDiv;
    });
  };

  const handleModal = (show: boolean, label: string, text: string) => {
    const updatedText = text.replace(/<img /g, '<img style="max-width: 100%; max-height: 500px;" ');
    setShow(show);
    setLabel(label);
    setText(updatedText);
  };

  return (
    <div className='text-center' tabIndex={0} aria-label='Hotspot' role='button'>
      <Carousel id='hotspot' controls={parameters.length > 1} indicators={false} interval={null}>
        {parameters.map((content: any, idx: number) => (
          <Carousel.Item key={idx}>
            <div className='hotspot' id={`hotspot_${idx}`}>
              {content?.dropZone?.map(
                (dropArea: { data: { label: string; text: string } }, index: number) => (
                  <div
                    key={`${dropArea.data.label}_${index}`}
                    className='hotspotIcon'
                    aria-label={dropArea.data.label}
                    onClick={() => handleModal(true, dropArea.data.label, dropArea.data.text)}
                    id={`${dropArea.data.label}_${idx}`}
                    tabIndex={0}
                    role='button'
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleModal(true, dropArea.data.label, dropArea.data.text);
                      }
                    }}
                  />
                ),
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      <ModalComponent
        dialogClassName='hotspot-submodal'
        show={show}
        handleCancel={() => handleModal(false, '', '')}
        modalDetails={{
          title: label,
          body: <>{ReactHtmlParser(text)}</>,
        }}
        isCentered
        modalType='previewHotSpot'
      />
    </div>
  );
};

export default HotspotViewComponent;
